module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Ga-Ha-Ia.534e5dfa.png";